import { render, staticRenderFns } from "./_FeedInTake.vue?vue&type=template&id=8b310a76&"
import script from "./_FeedInTake.vue?vue&type=script&lang=js&"
export * from "./_FeedInTake.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports